import { Component, OnInit } from '@angular/core';
import { DataService } from '../../utils/data.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../services/general.service';

@Component({
  selector: 'app-nota-cargo-eliminar',
  templateUrl: './nota-cargo-eliminar.component.html',
  styleUrls: ['./nota-cargo-eliminar.component.scss'],
  providers: [generalService]
})
export class NotaCargoEliminarComponent implements OnInit {

  mensaje: string = '';
  constructor(
    public dataService: DataService,
    private formBuilder: FormBuilder,
    private _generalService: generalService) {
  }

  ngOnInit() {
  }

  aceptar() {
    this.cancelNotaCredito();
  }

  cerrarModal() {
    this.dataService.dialogRef.close();
  }

  cancelNotaCredito() {
    const loacs  = sessionStorage.getItem('acslo');
    const notaCredito = {
      loacs: loacs,
      BILL_CHARGE_NOTE_ID: this.dataService.id,
      idCompania: this.dataService.factura.idCompania,
      ORGANIZATION_ID: this.dataService.factura.idOrganizacion,
      UUID: this.dataService.factura.uuid,
      TOTAL: this.dataService.factura.TOTAL,
      MOTIVO: this.dataService.factura.MOTIVO,
      CUSTOMER_ID: null,
    };
    this._generalService.metodoCallParams(notaCredito, `NotaCargo/cancel/`).subscribe(
          (result) => {
            this._generalService.toastCall('Se realizó la solcitud de cancelación exitosamente!');
            this.cerrarModal();
            },
          (error) => {
            console.log( error as any);
            this.cerrarModal();
          }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/nota-cargo/consultar-eliminar/nota-cargo-eliminar.component.ts